// 🌍 Upload direto para o servidor Trekkin.pt (CPANEL)
// Compatível com eventos, trilhos e fotos de perfil futuramente

export async function uploadImageToServer(file) {
  const form = new FormData();
  form.append("file", file);

  const res = await fetch("https://www.trekkin.pt/app/app-upload/upload-image.php", {
    method: "POST",
    body: form,
  });

  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Erro ao enviar imagem");

  return data.url;
}

export async function uploadGPXToServer(file) {
  const form = new FormData();
  form.append("file", file);

  const res = await fetch("https://www.trekkin.pt/app/app-upload/upload-gpx.php", {
    method: "POST",
    body: form,
  });

  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Erro ao enviar GPX");

  return data.url;
}